import React, { useCallback, useEffect, useRef } from 'react';
import * as S from './DropdownPopup.styles';

interface DropdownPopupProps {
  isOpen: boolean;
  onClose: () => void;
  align?: 'left' | 'right';
  className?: string;
}

export const DropdownPopup = ({
  isOpen,
  onClose,
  align = 'right',
  className,
  children,
}: React.PropsWithChildren<DropdownPopupProps>) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      const target = event.target as Node;
      const dropdown = dropdownRef?.current;
      const parent = dropdown?.parentElement;

      if (!dropdown?.contains(target) && !parent?.contains(target)) {
        event.stopPropagation();
        onClose();
      }
    },
    [onClose]
  );

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, handleClickOutside]);

  if (!isOpen) return null;

  return (
    <S.Dropdown
      ref={dropdownRef}
      $isOpen={isOpen}
      $align={align}
      className={className}
      onClick={handleClick}
    >
      {children}
    </S.Dropdown>
  );
};
